/**
 * Cart Rewards Bar — cart-rewards.js  v2
 * Shopify Impulse 7.4.1
 *
 * FIXES v2:
 * - Escucha ajaxProduct:added (evento real de Impulse al agregar al carrito)
 * - Escucha cart:updated (evento de Impulse después de cambiar cantidades)
 * - MutationObserver robusto para re-inicializar cuando Impulse re-renderiza la barra
 * - processingRewards con reset garantizado via try/catch
 * - _fetchAndUpdate siempre hace fetch fresco de /cart.js
 * - Impulse usa buildCart() internamente; para refrescar el drawer llamamos
 *   document.dispatchEvent(new CustomEvent('cart:build')) que CartForm escucha
 */

(function () {
  'use strict';

  var CartRewards = {
    bar: null,
    milestones: [],
    processingRewards: false,
    _observerAttached: false,

    // ── Init ──────────────────────────────────────────────────────────────────
    init: function () {
      this._findBar();
      this._bindGlobalEvents();

      // Si ya hay barra en el DOM, arrancar de una
      if (this.bar) {
        this._setup();
        this._fetchAndUpdate();
      }

      // Inicializar announcement bar (funciona independientemente del drawer)
      this._initAnnouncementBar();
    },

    _findBar: function () {
      this.bar = document.getElementById('cart-rewards-bar');
    },

    _setup: function () {
      this.milestones = this._parseMilestones();
      if (this.milestones.length) {
        this._positionDots();
        // Slight delay to let browser render the labels before measuring
        var self = this;
        setTimeout(function () { self._updateStageHeight(); }, 50);
      }
    },

    // ── Eventos globales (solo se registran una vez) ───────────────────────────
    _bindGlobalEvents: function () {
      var self = this;

      // 1. Producto añadido desde el formulario de producto (AjaxCart de Impulse)
      document.addEventListener('ajaxProduct:added', function () {
        self._fetchAndUpdate();
        self._initAnnouncementBar();
      });

      // 2. Cambio de cantidad en el carrito → Impulse dispara cart:updated
      document.addEventListener('cart:updated', function (e) {
        // cart:updated lleva e.detail.cart con el estado actualizado
        var cart = e.detail && e.detail.cart;
        if (cart) {
          self._update(cart.total_price, cart);
          self._processRewards(cart);
          self._updateAnnouncementBar(cart.total_price);
        } else {
          self._fetchAndUpdate();
          self._initAnnouncementBar();
        }
      });

      // 3. Observer: cuando Impulse re-renderiza [data-products], la barra
      //    puede ser destruida y recreada → re-inicializar
      if (!this._observerAttached) {
        this._observerAttached = true;
        var observer = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var mutation = mutations[i];
            // Buscar si algún nodo agregado contiene o ES la barra
            for (var j = 0; j < mutation.addedNodes.length; j++) {
              var node = mutation.addedNodes[j];
              if (node.nodeType !== 1) continue;
              var found = node.id === 'cart-rewards-bar'
                ? node
                : node.querySelector && node.querySelector('#cart-rewards-bar');
              if (found) {
                self.bar = found;
                self._setup();
                self._fetchAndUpdate();
                return;
              }
            }
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }
    },

    // ── Parsear metas desde data-attributes del snippet ───────────────────────
    _parseMilestones: function () {
      if (!this.bar) return [];
      var bar = this.bar;
      var milestones = [];

      for (var i = 1; i <= 4; i++) {
        var raw = bar.dataset['m' + i + 'Threshold'];
        var threshold = parseInt(raw || '0', 10);
        if (!threshold) continue;

        milestones.push({
          id: i,
          threshold: threshold,
          label: bar.dataset['m' + i + 'Label'] || 'Premio',
          type: bar.dataset['m' + i + 'Type'] || 'product',
          variantId: (bar.dataset['m' + i + 'Variant'] || '').trim(),
        });
      }

      milestones.sort(function (a, b) { return a.threshold - b.threshold; });
      return milestones;
    },

    // ── Posicionar dots Y milestones en el % exacto de la barra ─────────────
    _positionDots: function () {
      if (!this.milestones.length) return;
      var milestones = this.milestones;
      var maxThreshold = milestones[milestones.length - 1].threshold;
      var lastIndex = milestones.length - 1;

      milestones.forEach(function (m, idx) {
        var pct = Math.min((m.threshold / maxThreshold) * 100, 100);

        // Dot en la barra
        var dot = document.getElementById('crb-dot-' + m.id);
        if (dot) dot.style.left = pct + '%';

        // Milestone (ícono + label) posicionado en el mismo left%
        var milestoneEl = document.getElementById('crb-milestone-' + m.id);
        if (!milestoneEl) return;

        milestoneEl.style.left = pct + '%';

        // Primer milestone: arrancar desde la izquierda del punto
        if (idx === 0) {
          milestoneEl.classList.add('is-first');
          milestoneEl.classList.remove('is-last');
        // Último milestone: terminar a la izquierda del punto
        } else if (idx === lastIndex) {
          milestoneEl.classList.add('is-last');
          milestoneEl.classList.remove('is-first');
        // Intermedios: centrados
        } else {
          milestoneEl.classList.remove('is-first', 'is-last');
        }
      });
    },

    // ── Ajustar altura del stage según el milestone más alto ───────────────
    _updateStageHeight: function () {
      var stage = document.querySelector('.crb__stage');
      if (!stage) return;
      // Resetear para medir natural
      stage.style.minHeight = '';
      var maxHeight = 0;
      stage.querySelectorAll('.crb__milestone').forEach(function (el) {
        var h = el.offsetHeight;
        if (h > maxHeight) maxHeight = h;
      });
      if (maxHeight > 0) stage.style.minHeight = (maxHeight + 4) + 'px';
    },

    // ── Fetch fresco del carrito y actualizar todo ────────────────────────────
    _fetchAndUpdate: function () {
      var self = this;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self._update(cart.total_price, cart);
          self._processRewards(cart);
        })
        .catch(function (e) { console.warn('[CartRewards] fetch error:', e); });
    },

    // ── Arrancar announcement bar independientemente del drawer ───────────────
    _initAnnouncementBar: function () {
      var bar = document.getElementById('cart-rewards-announcement');
      if (!bar) return;
      var self = this;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self._updateAnnouncementBar(cart.total_price);
        })
        .catch(function (e) { console.warn('[CartRewards] announcement fetch error:', e); });
    },

    // ── Actualizar barra visualmente ──────────────────────────────────────────
    _update: function (subtotal, cart) {
      // Re-buscar bar por si fue recreada
      var bar = document.getElementById('cart-rewards-bar');
      if (!bar) return;
      if (bar !== this.bar) {
        this.bar = bar;
        this._setup();
      }
      if (!this.milestones.length) return;

      var maxThreshold = this.milestones[this.milestones.length - 1].threshold;

      // Subtotal a usar: total_price del carrito menos los ítems de premio
      // (para que los regalos no cuenten hacia el progreso)
      var rewardVariantIds = this.milestones
        .filter(function (m) { return m.type === 'product' && m.variantId; })
        .map(function (m) { return String(m.variantId); });

      var effectiveSubtotal = subtotal;
      if (cart && cart.items) {
        cart.items.forEach(function (item) {
          if (
            rewardVariantIds.includes(String(item.variant_id)) &&
            item.properties && item.properties._reward === 'true'
          ) {
            effectiveSubtotal -= item.line_price;
          }
        });
      }
      effectiveSubtotal = Math.max(effectiveSubtotal, 0);

      var pct = Math.min((effectiveSubtotal / maxThreshold) * 100, 100);

      // Barra
      var fill = document.getElementById('crb-fill');
      if (fill) {
        fill.style.width = pct + '%';
        fill.classList.toggle('has-progress', pct > 1);
      }

      // Milestones
      var allUnlocked = true;
      var nextMilestone = null;
      var self = this;

      this.milestones.forEach(function (m) {
        var unlocked = effectiveSubtotal >= m.threshold;
        if (!unlocked) {
          allUnlocked = false;
          if (!nextMilestone) nextMilestone = m;
        }

        var milestoneEl = document.getElementById('crb-milestone-' + m.id);
        var dotEl = document.getElementById('crb-dot-' + m.id);
        var wasUnlocked = milestoneEl && milestoneEl.classList.contains('is-unlocked');

        if (milestoneEl) {
          milestoneEl.classList.toggle('is-unlocked', unlocked);
          if (unlocked && !wasUnlocked) {
            milestoneEl.classList.add('just-unlocked');
            setTimeout(function () { milestoneEl.classList.remove('just-unlocked'); }, 600);
          }
        }
        if (dotEl) dotEl.classList.toggle('is-unlocked', unlocked);
      });

      // Mensaje en el drawer/barra de premios
      var msg = document.getElementById('crb-message');
      if (msg) {
        if (allUnlocked) {
          msg.className = 'crb__message is-complete';
          msg.innerHTML = '🎉 ¡Desbloqueaste todos los premios!';
        } else {
          msg.className = 'crb__message';
          var remaining = nextMilestone.threshold - effectiveSubtotal;
          msg.innerHTML = 'Agrega <strong>' + this._formatMoney(remaining) + '</strong> más y recibe <strong>' + nextMilestone.label + '</strong> 🎁';
        }
      }

      // Actualizar también el announcement bar
      this._updateAnnouncementBar(effectiveSubtotal);
    },

    // ── Agregar / quitar premios según el subtotal ────────────────────────────
    _processRewards: function (cart) {
      if (this.processingRewards) return;
      if (!this.milestones.length) return;

      this.processingRewards = true;
      var self = this;

      var subtotal = cart.total_price;
      var rewardVariantIds = this.milestones
        .filter(function (m) { return m.type === 'product' && m.variantId; })
        .map(function (m) { return String(m.variantId); });

      // Calcular subtotal efectivo (sin contar los propios premios)
      var effectiveSubtotal = subtotal;
      cart.items.forEach(function (item) {
        if (
          rewardVariantIds.includes(String(item.variant_id)) &&
          item.properties && item.properties._reward === 'true'
        ) {
          effectiveSubtotal -= item.line_price;
        }
      });
      effectiveSubtotal = Math.max(effectiveSubtotal, 0);

      var cartVariantIds = cart.items.map(function (i) { return String(i.variant_id); });

      var queue = Promise.resolve();

      this.milestones.forEach(function (m) {
        var shouldUnlock = effectiveSubtotal >= m.threshold;

        // ── Envío gratis ──
        if (m.type === 'free_shipping') {
          queue = queue.then(function () {
            return self._setFreeShippingAttribute(shouldUnlock);
          });
          return;
        }

        // ── Producto de regalo ──
        if (!m.variantId) return;
        var variantIdStr = String(m.variantId);
        var isInCart = cartVariantIds.includes(variantIdStr);

        if (shouldUnlock && !isInCart) {
          // Capturar m en closure
          (function (milestone) {
            queue = queue.then(function () {
              return self._addReward(milestone);
            });
          })(m);
        } else if (!shouldUnlock && isInCart) {
          // Solo quitar si es un premio (tiene propiedad _reward)
          var lineItem = cart.items.find(function (i) {
            return String(i.variant_id) === variantIdStr &&
              i.properties && i.properties._reward === 'true';
          });
          if (lineItem) {
            (function (key, label) {
              queue = queue.then(function () {
                return self._removeReward(key, label);
              });
            })(lineItem.key, m.label);
          }
        }
      });

      queue
        .then(function () { self.processingRewards = false; })
        .catch(function (e) {
          console.warn('[CartRewards] processRewards error:', e);
          self.processingRewards = false;
        });
    },

    // ── Agregar producto de regalo al carrito ─────────────────────────────────
    _addReward: function (milestone) {
      var self = this;

      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(milestone.variantId, 10),
            quantity: 1,
            properties: {
              _reward: 'true',
              _reward_milestone: String(milestone.id)
            }
          }]
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status >= 400) {
            console.warn('[CartRewards] No se pudo agregar premio "' + milestone.label + '":', data.description);
            return;
          }
          self._showToast('🎁 ¡Premio desbloqueado: ' + milestone.label + '!');
          // Decirle a Impulse que reconstruya el drawer
          document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(function (e) { console.warn('[CartRewards] _addReward error:', e); });
    },

    // ── Quitar producto de regalo del carrito ─────────────────────────────────
    _removeReward: function (lineKey) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(function (e) { console.warn('[CartRewards] _removeReward error:', e); });
    },

    // ── Atributo de envío gratis en el carrito ────────────────────────────────
    _setFreeShippingAttribute: function (enable) {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { free_shipping_reward: enable ? 'true' : '' }
        })
      }).catch(function (e) { console.warn('[CartRewards] _setFreeShipping error:', e); });
    },

    // ── Actualizar announcement bar con mensaje dinámico ─────────────────────
    _updateAnnouncementBar: function (effectiveSubtotal) {
      var bar = document.getElementById('cart-rewards-announcement');
      if (!bar) return;

      var msgEl = document.getElementById('crb-announcement-text');
      if (!msgEl) return;

      // Parsear milestones desde el announcement bar
      var milestones = [];
      for (var i = 1; i <= 3; i++) {
        var raw = bar.dataset['m' + i + 'Threshold'];
        var threshold = parseInt(raw || '0', 10);
        if (!threshold) continue;
        milestones.push({
          id: i,
          threshold: threshold,
          label: bar.dataset['m' + i + 'Label'] || 'Premio',
          msgPending: bar.dataset['m' + i + 'MsgPending'] || 'Faltan {amount} para {label}',
          msgReached: bar.dataset['m' + i + 'MsgReached'] || '¡Desbloqueaste {label}!'
        });
      }
      if (!milestones.length) return;

      milestones.sort(function (a, b) { return a.threshold - b.threshold; });

      // Si el carrito está vacío, mostrar texto inicial
      if (effectiveSubtotal === 0) {
        var initialText = bar.dataset.textInitial || '';
        if (initialText) {
          var currentHtmlEmpty = msgEl.innerHTML;
          if (currentHtmlEmpty !== initialText) {
            msgEl.classList.remove('is-animating');
            void msgEl.offsetWidth;
            msgEl.innerHTML = initialText;
            msgEl.classList.add('is-animating');
          }
        }
        return;
      }

      // Determinar el mensaje correcto
      var newHtml = '';
      var allReached = true;
      var nextMilestone = null;

      for (var j = 0; j < milestones.length; j++) {
        var m = milestones[j];
        if (effectiveSubtotal < m.threshold) {
          allReached = false;
          nextMilestone = m;
          break;
        }
      }

      if (allReached) {
        // Todos alcanzados: mostrar mensaje del último
        var last = milestones[milestones.length - 1];
        newHtml = last.msgReached.replace(/{label}/g, '<strong>' + last.label + '</strong>');
      } else if (nextMilestone) {
        // Hay un siguiente premio que alcanzar
        // ¿El premio anterior ya fue alcanzado? Mostrar su mensaje "reached" primero
        // si no, mostrar el pending del primero
        var prevReached = null;
        for (var k = 0; k < milestones.length; k++) {
          if (milestones[k].id === nextMilestone.id) break;
          if (effectiveSubtotal >= milestones[k].threshold) {
            prevReached = milestones[k];
          }
        }

        var remaining = nextMilestone.threshold - effectiveSubtotal;
        var formattedAmount = this._formatMoney(remaining);
        newHtml = nextMilestone.msgPending
          .replace(/{amount}/g, '<strong>' + formattedAmount + '</strong>')
          .replace(/{label}/g, '<strong>' + nextMilestone.label + '</strong>');
      }

      // Si no hay mensaje, usar el texto inicial (carrito vacío)
      if (!newHtml) {
        var initialText = bar.dataset.textInitial || '';
        if (initialText) newHtml = initialText;
        else return;
      }

      // Animar cambio si el texto es diferente
      var currentHtml = msgEl.innerHTML;
      if (currentHtml !== newHtml) {
        msgEl.classList.remove('is-animating');
        void msgEl.offsetWidth; // reflow para reiniciar animación
        msgEl.innerHTML = newHtml;
        msgEl.classList.add('is-animating');
      }
    },

    // ── Formato de dinero CLP ─────────────────────────────────────────────────
    _formatMoney: function (cents) {
      var amount = Math.round(cents / 100);
      return 'S/.' + amount.toLocaleString('es-CL');
    },

    // ── Toast de notificación ─────────────────────────────────────────────────
    _showToast: function (message) {
      var toast = document.getElementById('crb-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.id = 'crb-toast';
        toast.className = 'crb-toast';
        document.body.appendChild(toast);
      }
      toast.textContent = message;
      toast.classList.add('is-visible');
      clearTimeout(toast._t);
      toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 3500);
    }
  };

  // ── Arrancar ──────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { CartRewards.init(); });
  } else {
    CartRewards.init();
  }

})();